export default (price: number, discount: number) => price - price * discount;
